import { initVideo } from './video/index'

window.initVideo = initVideo
